
<div class="selector-body mat-elevation-z2">
    
    <div class="d-flex flex-column" style="gap: 16px; width: 100%;">

        <div>

            <div class="overline left-padding">Seccions inicials</div>
            <div class="d-flex flex-column">
                <ng-container *ngFor="let header of headerSections()" [ngTemplateOutlet]="sectionRow"
                    [ngTemplateOutletContext]="{ data: { section: header, icon: 'check' } }">
                </ng-container>
            </div>

        </div>

        <mat-divider></mat-divider>

        <div class="section-middle">
            <div>

                <div class="overline left-padding">Seccions intermèdies</div>
                <div cdkDropList (cdkDropListDropped)="dropSection($event)" [cdkDropListData]="middleSections()" cdkDropListOrientation="vertical"
                    class="d-flex flex-column example-list" [class.dd-container]="onDD" style="max-height: 440px;">
                
                    <app-page-scroll-content #current>

                        <div *ngFor="let middle of middleSections()" [class.dd-widget]="onDD" (cdkDragStarted)="startDD($event)"
                            (cdkDragEnded)="endDD($event)" [class.padding-r]="middleSections().length < 12" cdkDrag>

                            <ng-container  [ngTemplateOutlet]="sectionRow"
                                [ngTemplateOutletContext]="{ data: { section: middle, icon: 'check' } }">
                            </ng-container>

                        </div>

                    </app-page-scroll-content>

                </div>

            </div>
        </div>

        <mat-divider></mat-divider>

        <div class="section-footer">

            <div>

                <div class="overline left-padding">Seccions finals</div>
                <div class="d-flex flex-column">
                    <ng-container *ngFor="let header of footerSections()" [ngTemplateOutlet]="sectionRow"
                        [ngTemplateOutletContext]="{ data: { section: header, icon: 'check' } }">
                    </ng-container>
                </div>

            </div>

        </div>

    </div>

</div>


<ng-template #sectionRow let-data="data">

    <div (click)="goTo(data.section)" class="d-flex align-items-center icons-transform example-box"
        [class.check]="data.section.id == dynFormSection.id" style="gap: 0px; width: 100%; min-height: 40px;">
    
        <span class="material-icons-outlined check-color" [class.check-transparent]="data.section.id != dynFormSection.id"
            style="padding-left: 16px; padding-right: 16px;">
            {{data.icon}}
        </span>

        <div [matTooltip]="data.section.name" style="flex: 1 0 0; cursor: pointer; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
            {{data.section.name}}
        </div>

        <span class="material-icons-outlined">
            drag_handle
        </span>
    
    </div>

</ng-template>